import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';

import 'draft-js/dist/Draft.css';

import { Box, Stack, Typography, Checkbox, FormControlLabel, FormHelperText, Tooltip } from '@mui/material';

import { HelpOutlineIcon, MailOutlineIcon } from '../../constants/images';
import theme from '../../theme';

import { CustomFormLabel } from '../customComponent';

import SelectForm from '../form/SelectForm';

import useGlobalStatus from '../../hook/useGlobalStatus';
import useColorSystem from '../../hook/useColorSystem';

import { weekdayMenu, monthdayMenu } from '../../utils/sendDateIntl';
import * as basicConstants from '../../constants/basic';

import { EMAIL_REPORT_TYPE } from './data/emailConstants';


const SendTime = (props) => {
  const {
    media,
    sendTimeData,
    setSendTimeData,
    inputErrorMsg,
  } = props;

  const intl = useIntl();
  const { currentActiveData, setCurrentActiveData, locale, setLocale, entryPath, setEntryPath } = useGlobalStatus();
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  useEffect(() => {
    if (entryPath.includes('edit')) {
      setSendTimeData({
        reportType: currentActiveData.reportType.split(','),
        weekday: currentActiveData.sendDay - 1,
        monthday: currentActiveData.monthly - 1,
        biWeekDay: currentActiveData.biweekly_day ? currentActiveData.biweekly_day - 1 : 0,
        last30Day: currentActiveData.monthly - 1,
        weektime: basicConstants.HOUR_LIST.indexOf(currentActiveData.sendTime)
      })
    }
  }, [entryPath, currentActiveData])

  const getMenuData = (menuType) =>
    menuType === 'weekday' ? weekdayMenu(intl) : monthdayMenu(intl);

  const changeReportType = (e) => {
    const { name, checked } = e.target;

    setSendTimeData((prev) => {
      if (checked) {
        return {
          ...prev,
          reportType: [...prev.reportType, name],
        };
      } else {
        return {
          ...prev,
          reportType: prev.reportType.filter((el) => el !== name),
        };
      }
    });
  }

  const handleReportTypeDisabled = (value) => {
    if (value === "1" && sendTimeData.reportType.includes("4")) {
      return true;
    } else if (value === "4" && sendTimeData.reportType.includes("1")) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Box>
      <Typography
        sx={{
          ...theme.typography.h4_normal,
          mb: 2,
          color: theme.palette.grey.w700,
        }}
      >
        <MailOutlineIcon variant='subTitle' />
        <FormattedMessage id="common.title.setMail" />
      </Typography>

      <CustomFormLabel>
        <FormattedMessage id="sendTime.sendType.deliveryCycle" /><span>*</span>
        <Tooltip
          title={
            <Box sx={{ lineHeight: 1.5, padding: '4px' }}>
              <Typography variant='body_xs'><FormattedMessage id="sendTime.sendType.tip" /></Typography><br />
              <Typography variant='body_xs'><FormattedMessage id="sendTime.sendType.tip2" /></Typography><br />
              <Typography variant='body_xs'><FormattedMessage id="sendTime.sendType.tip3" /></Typography><br />
              <Typography variant='body_xs'><FormattedMessage id="sendTime.sendType.tip4" /></Typography><br />
              <Typography variant='body_xs'><FormattedMessage id="sendTime.sendType.tip5" /></Typography><br />
            </Box>
          }
          placement="bottom-start"
        >
          <HelpOutlineIcon variant="dark" />
        </Tooltip>
      </CustomFormLabel>

      {/* 寄送週期 */}
      <Box>
        <Box>
          {EMAIL_REPORT_TYPE.map((el) => {
            const disabled = handleReportTypeDisabled(el.value);
            return (
              <Stack key={el.id} mb={2}>
                <Box sx={{ pr: 1 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        name={el.value}
                        checked={sendTimeData?.reportType.includes(el.value)}
                        onChange={changeReportType}
                        color={colorMedia}
                        disabled={disabled}
                      />
                    }
                    label={<FormattedMessage id={el.label} />}
                    sx={{ width: '140px' }}
                  />
                </Box>

                <Box sx={{ width: '16%' }}>
                  <SelectForm
                    id={el.selectId}
                    selectValue={sendTimeData[el.selectId]}
                    setValue={setSendTimeData}
                    menuData={getMenuData(el.menuData)}
                    media={media}
                    disabled={disabled}
                  />
                </Box>
              </Stack>
            )
          })}
        </Box>

        <Box sx={{ mb: 2, mt: 0 }}>
          <FormHelperText error sx={{ fontSize: 14 }}>
            {inputErrorMsg?.reportType &&
              <FormattedMessage id={inputErrorMsg.reportType} />
            }
          </FormHelperText>
        </Box>

      </Box>

      {/* 寄送時間 */}
      <Stack mb={2}>
        <Box sx={{ width: '100%' }}>
          <CustomFormLabel><FormattedMessage id="common.sendDate.sendTime" /><span>*</span>
            <Tooltip title={<FormattedMessage id="sendTime.mailingTime.tip" />} placement="bottom-start">
              <HelpOutlineIcon variant="dark" />
            </Tooltip>
          </CustomFormLabel>

          <Stack
            variant='center-center'
            sx={{ width: '16%', mr: '10px' }}
          >
            <SelectForm
              id="weektime"
              selectValue={sendTimeData.weektime}
              setValue={setSendTimeData}
              menuData={basicConstants.HOUR_LIST}
              media={media}
            />
          </Stack>

        </Box>
      </Stack>
    </Box>
  )
}

export default SendTime;